import React from 'react';
import { Search, ChevronDown } from 'lucide-react';

const StaffFilters = ({
  query,
  staffType,
  department,
  status,
  onQueryChange,
  onStaffTypeChange,
  onDepartmentChange,
  onStatusChange,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-4">
      <div className="flex flex-col lg:flex-row gap-3">
        
        {/* Search */}
        <div className="relative flex-1">
          <Search className="w-5 h-5 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" />

          <input
            type="text"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder="Search by name, employee ID, phone, email..."
            className="w-full h-12 pl-12 pr-4 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
          />
        </div>

        {/* Staff Type */}
        <div className="relative min-w-[160px]">
          <select
            value={staffType}
            onChange={(e) => onStaffTypeChange(e.target.value)}
            className="w-full h-12 px-4 border border-gray-200 rounded-xl text-sm appearance-none bg-white focus:outline-none focus:border-blue-500"
          >
            <option value="">Staff Type</option>
            <option value="TEACHING">Teaching</option>
            <option value="NON_TEACHING">Non-Teaching</option>
          </select>

          <ChevronDown className="w-4 h-4 absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none" />
        </div>

        {/* Department */}
        {/* <div className="relative min-w-[160px]">
          <select
            value={department}
            onChange={(e) => onDepartmentChange(e.target.value)}
            className="w-full h-12 px-4 border border-gray-200 rounded-xl text-sm appearance-none bg-white focus:outline-none focus:border-blue-500"
          >
            <option value="">Department</option>
            <option value="Mathematics">Mathematics</option>
            <option value="Science">Science</option>
            <option value="Commerce">Commerce</option>
            <option value="Administration">Administration</option>
            <option value="Library">Library</option>
          </select>

          <ChevronDown className="w-4 h-4 absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none" />
        </div> */}

        {/* Status */}
        <div className="relative min-w-[140px]">
          <select
            value={status}
            onChange={(e) => onStatusChange(e.target.value)}
            className="w-full h-12 px-4 border border-gray-200 rounded-xl text-sm appearance-none bg-white focus:outline-none focus:border-blue-500"
          >
            <option value="">Status</option>
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
          </select>

          <ChevronDown className="w-4 h-4 absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none" />
        </div>

      </div>
    </div>
  );
};

export default StaffFilters;